import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconAutomatedWorkspace = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon-automated-workspace",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.1859 22.1859C12.806 23.3255 11.194 23.3255 10.8141 22.1859L9.40203 16.5924C8.80005 14.2079 5.4726 13.7721 3.47665 13.2019C2.26786 12.8565 2.26785 11.1434 3.47665 10.7981C5.46706 10.2294 8.79504 9.81195 9.39682 7.42828L10.8141 1.81416C11.194 0.674527 12.806 0.674546 13.1859 1.81416C13.5811 2.99983 14.2133 5.61019 14.6174 7.33661C15.1933 9.79715 18.511 10.143 20.5234 10.7981C21.7322 11.1434 21.7322 12.8565 20.5234 13.2019C18.5274 13.7721 15.2 14.2079 14.598 16.5924L13.1859 22.1859ZM12 21L13.2714 15.9143C13.9428 13.2288 16.9666 12.6581 19.27 12C16.9409 11.2336 13.9464 10.7693 13.2952 7.97358C12.9063 6.30394 12.3737 4.12114 12 3.00001L10.7244 8.10239C10.0521 10.7918 7.03216 11.3422 4.73007 12C7.02598 12.7555 10.0507 13.2027 10.735 15.9399L12 21Z",
			fill: "currentColor"
		})
	})
});
export { SvgIconAutomatedWorkspace as ReactComponent };
